@if (!inputService.hidden && inputService.formInputDefinition) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence' [ngClass]='$safeNavigationMigration(inputService?.formInputDefinition?.inputConfig?.customCssClass)'>
      <mat-label style='pointer-events: auto;'>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      <textarea cdkTextareaAutosize [readonly]='inputService.inputConfig.readOnly' matInput [placeholder]="inputService.inputConfig.placeholder | translate" [formControlName]='inputService.formControlKey'></textarea>
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}